import cn from 'classnames';

import ContentContainer from 'components/content-container/ContentContainer';
import { ContentWithSidebar, Sidebar, Content } from 'components/content-with-sidebar';
import StickyMenuOnTabs from 'components/sticky-menu-on-tabs/StickyMenuOnTabs';
import SimpleTabContentSection from 'components/tab-content-section-simple/TabContentSectionSimple';

import { IStickyMenuOnTabs, ITibiTabContent } from 'source/NFR.types';

const buildMenuData = (
  menuTitle: ITibiTabContent['menuTitle'],
  contentSections: ITibiTabContent['contentSections']
): IStickyMenuOnTabs => {
  return {
    title: menuTitle,

    navGroups: contentSections.map(section => {
      const titleLink = section.sectionTitle
        ? {
            text: section.sectionTitle,
            url: `#${section.htmlId}`
          }
        : undefined;

      const links = section.subSections && {
        items: section.subSections
          .filter(x => x)
          .map(x => {
            return {
              link: {
                text: x.title ?? '',
                url: `#${x.htmlId}`
              }
            };
          })
      };

      return {
        titleLink,
        ...(links && { links })
      };
    })
  };
};

const TibiTabContent: React.FC<ITibiTabContent> = ({ menuTitle, contentSections }) => {
  const className = 'tab-content';
  const menu = buildMenuData(menuTitle, contentSections);

  const tibiTabContent = (
    <>
      {contentSections?.map((contentSection, index) => (
        <SimpleTabContentSection {...contentSection} key={index} />
      ))}
    </>
  );

  return !menu ? (
    <ContentContainer theme="medium" className={className}>
      {tibiTabContent}
    </ContentContainer>
  ) : (
    <ContentContainer className={cn(className, 'tab-content__container')} theme="wide">
      <ContentWithSidebar theme="sidebarLeft" className="tab-content__grid" useContentContainer={false}>
        <Sidebar>
          <StickyMenuOnTabs {...menu} />
        </Sidebar>
        <Content className="tab-content__content">{tibiTabContent}</Content>
      </ContentWithSidebar>
    </ContentContainer>
  );
};

TibiTabContent.displayName = 'TibiTabContent';

export default TibiTabContent;
